import {useEffect, useRef} from "react"

export default function useOnUpdate(callback, dependVariables = []) {
  const isFirstRef = useRef(true)
  useEffect(() => {
    if (isFirstRef.current) {
      isFirstRef.current = false
    } else {
      callback()
    }
  }, dependVariables)
}
